module.exports = __webpack_public_path__ + "static/media/Body.996ba141.svg";